export default __webpack_public_path__ + "static/media/unlocked.1a149e05.svg";